import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

interface ITableTitle {
  title: string;
}

export default function TableTitle(props: ITableTitle) {
  const isViewPageInPage = false;

  return (
    <div
      style={{ fontFamily: 'Roboto' }}
      className={classNames(isViewPageInPage && 'hidden', 'select-none text-lg text-center uppercase')}
    >
      {props.title}
    </div>
  );
}
